import { WS_DOMAIN } from "../constants"

export const clsPrefix = 'cap-documentation-bot';

export const MESSAGE_GET_ANSWER = "MESSAGE_GET_ANSWER"
export const MESSAGE_CHUNK = "MESSAGE_CHUNK"
export const MESSAGE_METADATA = "MESSAGE_METADATA"
export const MESSAGE_COMPLETE = "MESSAGE_COMPLETE"
export const MESSAGE_LIKE = "MESSAGE_LIKE"
export const MESSAGE_DISLIKE = "MESSAGE_DISLIKE"

export const SERVER_URL = `${WS_DOMAIN}/arya/api/v1/ask-aira-service/doc_bot/query_stream`
export const DOCS_URL = 'https://docs.capillarytech.com/'
export const MOCK_WS_URL = 'ws://cap-doc-mock-websocket';
